import { findLastKey, get, has, orderBy } from 'lodash4';
import { PlannedTerm } from '../../../../../../global/builders/planned_term_builder';

export class APPreviewPlanServant {
  static getEstimatedGraduationDateFromTerm(terms: PlannedTerm[]) {
    const termsOrdered = orderBy(terms, 'rank', 'asc');
    const lastTermObj = termsOrdered[findLastKey(termsOrdered)];
    return get(lastTermObj, 'name', '');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_terms_plan_header/servants/ap_preview_plan_servant.ts